const definitions = {
	datapas_logo_url: __DATAPAS_APPLICATION_URL__ + "/dtps/images/datapas_logo.png",
	login_background_style: 'background-image: radial-gradient(at center, rgba(255,0,0,0), #011d47), url("' + __DATAPAS_APPLICATION_URL__ + '/dtps/images/login_background.jpg");'
}

export class DefinitionsPlugin {
	static install(app) {
		app.config.globalProperties.$definitions = definitions;
	}
}